import { useFormContext } from 'react-hook-form';
import { FormSelectionCardGroupField, LocalizedText, lt } from '@mews/framework';
import { Icon, IconName, Title } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedSmallParagraph } from '@mews-commander/ui';
import { Option } from '@optimus-web/core/src/SelectionCardGroup/SelectionCardGroup';
import { TargetBillType } from '../../../../schemas';
import { RoutingRulesFormFields } from '../../utils';
import { aggregationTypeOptions, includeCompanyDetailsOption } from './constants';

const getTargetTypeOptions = (areCompaniesEnabled: boolean): Option[] => [
    {
        media: <Icon value={IconName.Profiles} variant="basic" />,
        label: lt(TextKey.RoutingRulesGuestBill),
        value: TargetBillType.GuestBill,
        name: TargetBillType.GuestBill,
    },
    {
        media: <Icon value={IconName.Companies} variant="basic" />,
        label: lt(TextKey.RoutingRulesCompanyBill),
        value: TargetBillType.CompanyBill,
        name: TargetBillType.CompanyBill,
        disabled: !areCompaniesEnabled,
    },
];

export const TargetBillFields = () => {
    const { watch } = useFormContext();
    const targetTypeValue = watch(RoutingRulesFormFields.targetType());
    const areCompaniesEnabled = watch(RoutingRulesFormFields.companiesEnabled());

    return (
        <>
            <Title level={2}>
                <LocalizedText textKey={TextKey.RoutingRulesFormStepNameTargetBill} />
            </Title>
            <LocalizedSmallParagraph textKey={TextKey.RoutingRulesFormFieldDescriptionTargetType} variant="secondary" />
            <FormSelectionCardGroupField
                type="radio"
                templateColumns="1fr 1fr"
                name={RoutingRulesFormFields.targetType()}
                options={getTargetTypeOptions(areCompaniesEnabled)}
            />
            {targetTypeValue === TargetBillType.CompanyBill && (
                <>
                    <LocalizedSmallParagraph
                        textKey={TextKey.RoutingRulesFormFieldDescriptionAggregationType}
                        variant="secondary"
                    />
                    <FormSelectionCardGroupField
                        type="radio"
                        name={RoutingRulesFormFields.aggregationType()}
                        options={aggregationTypeOptions}
                    />
                </>
            )}
            {targetTypeValue === TargetBillType.GuestBill && (
                <FormSelectionCardGroupField
                    type="checkbox"
                    name={RoutingRulesFormFields.includeCompanyDetails()}
                    options={includeCompanyDetailsOption}
                />
            )}
        </>
    );
};
